export default __webpack_public_path__ + "static/media/KRW.566e12a1.png";